import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "../../reactRoute/RouteConstants";
import { MenuIcon } from "../../icons";
import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";

function Navbar() {
    const location = useLocation();
    const active = "relative after:absolute after:content-[''] after:w-full after:h-[2px] after:bg-[var(--primary)] after:-bottom-[2px] after:left-0";
    const activeMobile = "!text-[#1C9943]";
    const isActive = (route) => location.pathname === route;

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const closeDropdown = () => {
            setIsDropdownOpen(false);
        };

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                closeDropdown();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    useEffect(() => {
        const tl = gsap.timeline({ paused: true });

        if (isDropdownOpen) {
            tl.to(dropdownRef.current, { height: "auto", opacity: 1, duration: 0.3, ease: "power2.inOut" });
        } else {
            tl.to(dropdownRef.current, { height: 0, opacity: 0, duration: 0.3, ease: "power2.inOut" });
        }

        tl.play();
    }, [isDropdownOpen]);

    return (
        <div className="px-[4vw] py-[20px] flex items-center justify-between bg-[#FAFAFA]">
            <img src="/images/logo.png" alt="" />
            <div className="flex items-center gap-[40px] max-lg:hidden">
                <Link to={ROUTES.home} className={`${isActive(ROUTES.home) ? active : ""} font-bold text-[#333]`}>
                    Home
                </Link>
                <Link to={ROUTES.about} className={`${isActive(ROUTES.about) ? active : ""} font-bold text-[#333]`}>
                    About Us
                </Link>
                <Link to={ROUTES.treatements} className={`${isActive(ROUTES.treatements) ? active : ""} font-bold text-[#333]`}>
                    Treatments
                </Link>
                <Link to={ROUTES.contactUs} className={`${isActive(ROUTES.contactUs) ? active : ""} font-bold text-[#333]`}>
                    Contact Us
                </Link>
            </div>

            <div className="flex items-center gap-[24px] relative">
                <MenuIcon iconColor={'#1C9943'} className={'lg:hidden'} onClick={toggleDropdown} />
                <div ref={dropdownRef} className="flex flex-col gap-[20px] absolute top-[190%] right-[160px] min-w-[180px] p-[20px] rounded-[16px] bg-[#FAFAFA] shadow-emerald-200 z-[4] lg:hidden" style={{ height: 0, opacity: 0, overflow: "hidden" }}>
                    <Link to={ROUTES.home} className={`${isActive(ROUTES.home) ? activeMobile : ""} font-bold text-[#333]`}>
                        Home
                    </Link>
                    <Link to={ROUTES.about} className={`${isActive(ROUTES.about) ? activeMobile : ""} font-bold text-[#333]`}>
                        About Us
                    </Link>
                    <Link to={ROUTES.treatements} className={`${isActive(ROUTES.treatements) ? activeMobile : ""} font-bold text-[#333]`}>
                        Treatments
                    </Link>
                    <Link to={ROUTES.contactUs} className={`${isActive(ROUTES.contactUs) ? activeMobile : ""} font-bold text-[#333]`}>
                        Contact Us
                    </Link>
                </div>
                <Link to={ROUTES.contactUs} className="flex items-center py-[10px] px-[18px] bg-[var(--primary)] text-[#FFFFFF] rounded-[10px] font-bold">
                    Get in touch
                </Link>
            </div>
        </div>
    );
}

export default Navbar;
